import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-page">
      <div className="about-content">
        <h1>A NEW STANDARD</h1>
        <h2>Crafted with Intent. Based in Yorkshire.</h2>
        
        <h3>Our Philosophy</h3>
        <p>We're not just another spirits brand; we're an experience.</p>
        <p>Fire House Spirits was built on a single, uncompromising idea: to create a bougie, unique, and modern standard for small batch spirits.</p>
        <p>"Crafted with intent" is our promise. It's a refusal to present anything less than exceptional. For us, that meant a journey—visiting numerous distilleries and seeking out uncompromising quality until we procured spirits that we were proud to put our name on.</p>
        <p>This is our standard. This is craftsmanship, bottled.</p>

        <hr className="divider" />

        <h3>The Spark & The Name</h3>
        <p>Our name is an authentic nod to our family's other venture: a vintage fire engine business. This is Fire House Spirits.</p>
        <p>Our foundation is the dedication to that craft. And as a final tribute—a clever pun we just couldn't resist—our signature gin is named Fire En-Gin.</p>
        <p>It's a brand born from Yorkshire dedication, sparked by a bit of spontaneous inspiration.</p>

        <hr className="divider" />
        
        <h3>The Invitation</h3>
        <p>This philosophy is what you taste in every bottle. It’s the complex, smouldering oak of our Fire Engin Gin, the deeply complex, charred oak of our Smokey Timber Rum, and the molten heart of creamy fudge in our Bonfire Toffee Vodka.</p>
        <p>This is Fire House Spirits.</p>
        <p>Welcome to the house.</p>
      </div>
    </section>
  );
};

export default About;
